export default __webpack_public_path__ + "static/media/cont2.c66f4955.jpg";